export default __webpack_public_path__ + "static/media/facebookGaming.b14d3649.svg";